export default __webpack_public_path__ + "static/media/hypepay.0a180a38.ico";